module.exports = __webpack_public_path__ + "img/10871_L.dd5ab05c.png";